module.exports = __webpack_public_path__ + "img/img_card@2x.c5b043c2.png";